import Component from './CardSlider.vue';
import { ComponentProps as _ComponentProps } from './types';

type ComponentProps = _ComponentProps;

export { ComponentProps };
export default Component;



// WEBPACK FOOTER //
// ./src/components/parts/slider/images/index.ts